module.exports = __webpack_public_path__ + "static/img/XMSH05.71c2517f.jpg";